import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Necesito comprar suplementos caros?',
    a: 'No, todo lo que necesitas está en el pasillo de frescos de tu supermercado local.'
  }, {
    q: '¿Tengo que dejar de comer comida latina?',
    a: 'No, aprenderás a hacer intercambios inteligentes para seguir disfrutando del sabor sin la hinchazón.'
  }, {
    q: '¿Es difícil de seguir si trabajo mucho?',
    a: 'Está diseñado para mujeres ocupadas con menús que se preparan en menos de 20 minutos.'
  }, {
    q: '¿Recibo algo por correo físico?',
    a: 'No, es un producto 100% digital que puedes descargar y leer en tu teléfono o tablet de inmediato.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-white py-16 md:py-24 px-6" data-id="element-22">
      <div className="text-container" data-id="element-23">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-24">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-25">
          {faqs.map((faq, index) => <div key={index} className={`border rounded-2xl overflow-hidden transition-all duration-300 ${openIndex === index ? 'border-sage-dark bg-cream shadow-sm' : 'border-gray-200 bg-white hover:border-sage-light'}`} data-id="element-26">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} aria-expanded={openIndex === index} data-id="element-27">
                <span className="font-bold text-lg text-charcoal-dark font-sans pr-4" data-id="element-28">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-sage-dark transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-29" />
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-30">
                <p className="text-charcoal-light text-lg" data-id="element-31">{faq.a}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}